import React, { useState, useEffect } from "react";
import { Typography, Alert, Select, Empty } from "antd";
import axios from "axios";
import moment from "moment";
import { ModalItem, ButtonItem, SelectItem, TextAreaItem } from "../../../../Components/Items";
import { formatTelefono } from "../../../../Utils/whatsapp.utils";
import { WA } from "../theme";

const { Text } = Typography;
const { Option } = Select;

const mensajeSugerido = (usuario) =>
  usuario
    ? `A partir de ahora te atiende ${usuario.nombre}, desde el número ${usuario.numeroDisplay}. En un momento te escribe por ahí.`
    : "";

const ModalPasarChat = ({ visible, conversacion, headersToken, onPasar, onCancel }) => {
  const [usuarios, setUsuarios] = useState([]);
  const [usuarioId, setUsuarioId] = useState(null);
  const [mensaje, setMensaje] = useState("");
  const [editado, setEditado] = useState(false);
  const [cargando, setCargando] = useState(false);

  useEffect(() => {
    if (!visible) return;
    setCargando(true);
    axios
      .post("whatsapp/usuariosConLinea", {}, { headers: headersToken })
      .then((r) => {
        if (r.data.success === 2) setUsuarios(r.data.usuarios || []);
      })
      .finally(() => setCargando(false));
  }, [visible, headersToken]);

  const limpiar = () => {
    setUsuarioId(null);
    setMensaje("");
    setEditado(false);
  };

  const handleCancel = () => {
    limpiar();
    onCancel();
  };

  const elegirUsuario = (valor) => {
    setUsuarioId(valor);
    if (!editado) {
      setMensaje(mensajeSugerido(usuarios.find((u) => String(u._id) === String(valor))));
    }
  };

  if (!visible || !conversacion) return null;

  const lineaActual = conversacion.lineaWhatsappId?._id || conversacion.lineaWhatsappId;
  const disponibles = usuarios.filter((u) => String(u.lineaId) !== String(lineaActual || ""));
  const ventanaAbierta =
    conversacion.ventanaAbiertaHasta && moment(conversacion.ventanaAbiertaHasta).isAfter(moment());

  return (
    <ModalItem
      title="Pasar chat a un vendedor"
      visible={visible}
      onCancel={handleCancel}
      footer={null}
      spinning={cargando}
    >
      <div style={{ marginBottom: 16 }}>
        <Text style={{ color: WA.textSecondary }}>
          Cliente: <b>{formatTelefono(conversacion.telefono)}</b>
        </Text>
      </div>

      <Alert
        type="warning"
        showIcon
        style={{ marginBottom: 16 }}
        message="El cliente va a recibir desde otro número"
        description={
          <>
            El chat completo se mueve al número del vendedor que elijas, y él tendrá que{" "}
            <b>arrancar con una plantilla</b>, porque desde su número todavía no hay ventana de 24
            horas abierta con este cliente.
          </>
        }
      />

      {disponibles.length === 0 && !cargando ? (
        <Empty description="Ningún otro usuario tiene un número conectado" />
      ) : (
        <>
          <div style={{ marginBottom: 12 }}>
            <Text strong style={{ color: WA.textPrimary }}>
              Vendedor
            </Text>
            <SelectItem
              placeholder="Vendedor"
              value={usuarioId}
              onChange={elegirUsuario}
              style={{ width: "100%" }}
            >
              {disponibles.map((u) => (
                <Option key={u._id} value={u._id}>
                  {u.nombre} — {u.numeroDisplay}
                </Option>
              ))}
            </SelectItem>
          </div>

          <div>
            <Text strong style={{ color: WA.textPrimary }}>
              Aviso para el cliente
            </Text>
            <div style={{ fontSize: 12, color: WA.textSecondary, marginBottom: 4 }}>
              Sale desde el número actual, antes de mover el chat. Déjalo vacío si no quieres que
              el cliente reciba ningún aviso.
            </div>
            <TextAreaItem
              rows={3}
              value={mensaje}
              placeholder="Elige un vendedor para llenar el aviso"
              onChange={(e) => {
                setMensaje(e.target.value);
                setEditado(true);
              }}
            />
            {!ventanaAbierta && mensaje.trim() ? (
              <div style={{ fontSize: 12, color: WA.naranja, marginTop: 4 }}>
                La ventana de 24h está cerrada, así que este aviso no se va a poder entregar. El
                chat sí se pasa.
              </div>
            ) : null}
          </div>
        </>
      )}

      <div style={{ display: "flex", justifyContent: "flex-end", gap: 8, marginTop: 20 }}>
        <ButtonItem gris onClick={handleCancel}>
          Cancelar
        </ButtonItem>
        <ButtonItem
          lima
          disabled={!usuarioId}
          onClick={() => onPasar(conversacion._id, usuarioId, mensaje, limpiar)}
        >
          Pasar chat
        </ButtonItem>
      </div>
    </ModalItem>
  );
};

export default ModalPasarChat;
